(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-party-inquiry"] && !Shopify.designMode) return;
  try {
    
/* Creative Corner: manually maintained date/time availability, version 2.
 * No third-party libraries. Entry times are actual occupied periods; padding is
 * applied ONCE to each timed block. Candidate bookings must fit in full outside
 * those padded intervals. Touching an interval boundary is allowed.
 * Uses studio-local civil dates/minutes, not the visitor's timezone.
 * This is an inquiry UI; it is NOT server-side booking enforcement or a lock.
 */
(() => {
  'use strict';
  const ROOT = '[data-cc-date-picker]';
  const instances = new WeakMap();
  const DAY_MS = 86400000;
  const MINUTES_PER_DAY = 1440;
  const MIN_YEAR = 1000;
  const MAX_YEAR = 9999;

  function fromISO(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;
    const [year, month, day] = match.slice(1).map(Number);
    if (year < MIN_YEAR || year > MAX_YEAR) return null;
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return Math.floor(date.getTime() / DAY_MS);
  }
  function fromTime(value, allowMidnightEnd = false) {
    const match = /^(\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;
    const hour = Number(match[1]);
    const minute = Number(match[2]);
    if (allowMidnightEnd && hour === 24 && minute === 0) return 1440;
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59 ? hour * 60 + minute : null;
  }
  const timeValue = minute => `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
  function timeLabel(minute) {
    const hour = Math.floor(minute / 60) % 24;
    return `${hour % 12 || 12}:${String(minute % 60).padStart(2, '0')} ${hour < 12 ? 'AM' : 'PM'}`;
  }
  const iso = day => new Date(day * DAY_MS).toISOString().slice(0, 10);
  const dateOf = day => new Date(day * DAY_MS);
  const applies = (rule, scope) => rule.scope === 'both' || rule.scope === scope;
  const overlaps = (aStart, aEnd, bStart, bEnd) => aStart < bEnd && aEnd > bStart;
  function monthOf(day) {
    const d = dateOf(day);
    return Math.floor(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1) / DAY_MS);
  }
  function shiftMonth(day, amount) {
    const d = dateOf(day);
    const first = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + amount, 1));
    if (first.getUTCFullYear() < MIN_YEAR || first.getUTCFullYear() > MAX_YEAR) return day;
    const last = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
    return Math.floor(Date.UTC(first.getUTCFullYear(), first.getUTCMonth(), Math.min(d.getUTCDate(), last)) / DAY_MS);
  }

  /* Pure availability calculation. All intervals are half-open [start,end).
   * At defaults, a 12:00-14:00 block becomes 11:00-15:00; a 09:00-11:00
   * candidate is allowed and 09:30-11:30 is not. Do not pad the candidate again.
   * Timed buffers can extend into a neighboring date. Whole dates do not have
   * extra padding added; they are unavailable from midnight to midnight.
   */
  function availableStarts(day, scope, clock, config, dateRules, timeRules) {
    if (!Number.isInteger(day) || !scope || day < clock.minimum || day > fromISO('9999-12-31')) return [];
    if (dateRules.some(rule => applies(rule, scope) && day >= rule.start && day <= rule.end)) return [];
    const answer = [];
    for (let minute = config.first; minute <= config.last; minute += config.step) {
      const start = day * MINUTES_PER_DAY + minute;
      const end = start + config.duration;
      // On the current day, do not offer past start times or setup in the past.
      if (start - config.before < clock.now) continue;
      if (timeRules.some(rule => applies(rule, scope) && overlaps(start, end, rule.start, rule.end))) continue;
      // Also handles a midnight end without blocking the next calendar day.
      if (dateRules.some(rule => applies(rule, scope) && overlaps(start, end, rule.start * MINUTES_PER_DAY, (rule.end + 1) * MINUTES_PER_DAY))) continue;
      answer.push(minute);
    }
    return answer;
  }

  function initialize(root) {
    if (instances.has(root)) return;
    const cleanup = new AbortController();
    const signal = cleanup.signal;
    const form = root.querySelector('form');
    const reservation = root.querySelector('[data-cc-reservation-type]');
    const dialog = root.querySelector('[data-cc-calendar]');
    const submit = root.querySelector('[data-cc-inquiry-submit]');
    const status = root.querySelector('[data-cc-calendar-status]');
    const adminError = root.querySelector('[data-cc-admin-errors]');
    if (!form || !reservation || !dialog || !submit || !status) return;
    const fields = [...root.querySelectorAll('[data-cc-date-field]')].map(wrapper => {
      const key = wrapper.dataset.ccDateField;
      const timeWrapper = root.querySelector(`[data-cc-time-field="${key}"]`);
      return {
        key, wrapper,
        input: wrapper.querySelector('[data-cc-date-value]'),
        button: wrapper.querySelector('[data-cc-date-button]'),
        text: wrapper.querySelector('[data-cc-date-text]'),
        clear: wrapper.querySelector('[data-cc-date-clear]'),
        error: wrapper.querySelector('[data-cc-date-error]'),
        time: timeWrapper?.querySelector('[data-cc-time-select]'),
        timeHelp: timeWrapper?.querySelector('[data-cc-time-help]'),
        timeError: timeWrapper?.querySelector('[data-cc-time-error]'),
        end: timeWrapper?.querySelector('[data-cc-end-time]'),
        required: key === 'preferred',
        label: key === 'preferred' ? 'Preferred date' : 'Alternate date'
      };
    });
    const title = dialog.querySelector('[data-cc-calendar-title]');
    const monthLabel = dialog.querySelector('[data-cc-calendar-month]');
    const body = dialog.querySelector('tbody');
    const previous = dialog.querySelector('[data-cc-month-prev]');
    const next = dialog.querySelector('[data-cc-month-next]');
    const close = dialog.querySelector('[data-cc-calendar-close]');
    let active = null;
    let focusedDay = null;
    let viewMonth = null;
    let failed = false;
    let fullFormatter, shortFormatter, monthFormatter, clockFormatter;
    let clock = { today: null, minimum: null, now: 0 };
    let config;
    const rules = [];
    const timeRules = [];
    const cache = new Map();
    const leadDays = Number(root.dataset.ccLeadDays || 0);
    let timer;

    function listen(target, name, handler, options = {}) {
      target.addEventListener(name, handler, { ...options, signal });
    }
    function fail(message) {
      failed = true;
      submit.disabled = true;
      fields.forEach(field => { field.button.disabled = true; if (field.time) field.time.disabled = true; });
      if (dialog.open) dialog.close();
      status.textContent = 'Availability is temporarily unavailable. Please refresh the page or contact the studio directly.';
      status.classList.add('cc-availability-error');
      if (adminError) {
        adminError.hidden = false;
        adminError.textContent = 'Availability setup: ' + message;
      }
      console.error('Creative Corner availability:', message);
    }
    function currentScope() {
      if (reservation.value === 'Hosted Creative Experience') return 'hosted';
      if (reservation.value === 'Studio Rental - Venue Only') return 'rental';
      return '';
    }
    function updateClock() {
      const parts = Object.fromEntries(clockFormatter.formatToParts(new Date()).map(part => [part.type, part.value]));
      const today = fromISO(`${parts.year}-${parts.month}-${parts.day}`);
      const hour = Number(parts.hour) % 24;
      const minute = Number(parts.minute);
      const second = Number(parts.second);
      if (today === null || !Number.isFinite(hour + minute + second)) throw new Error('Cannot determine the studio local date and time.');
      clock = { today, minimum: today + leadDays, now: today * MINUTES_PER_DAY + hour * 60 + minute + second / 60 };
      cache.clear();
    }
    function choices(day) {
      if (failed) return [];
      const scope = currentScope();
      const key = `${scope}:${day}`;
      if (!cache.has(key)) cache.set(key, availableStarts(day, scope, clock, config, rules, timeRules));
      return cache.get(key);
    }
    function unavailable(day) { return choices(day).length === 0; }
    function setError(field, message) {
      field.error.textContent = message;
      field.error.hidden = !message;
      field.button.setAttribute('aria-invalid', message ? 'true' : 'false');
    }
    function setTimeError(field, message) {
      field.timeError.textContent = message;
      field.timeError.hidden = !message;
      field.time.setAttribute('aria-invalid', message ? 'true' : 'false');
    }
    function showField(field) {
      const day = fromISO(field.input.value);
      field.text.textContent = day !== null ? shortFormatter.format(dateOf(day)) : currentScope() ? 'Choose a date' : 'Choose reservation type first';
      field.clear.hidden = !field.input.value;
      field.button.setAttribute('aria-label', `${field.label}: ${day !== null ? shortFormatter.format(dateOf(day)) : 'choose a date'}`);
    }
    function updateEnd(field) {
      const minute = fromTime(field.time.value);
      field.end.value = minute === null ? '' : timeValue(minute + config.duration);
    }
    function renderTimes(field, preserve = true) {
      const oldValue = preserve ? field.time.value : '';
      const day = fromISO(field.input.value);
      const starts = day === null ? [] : choices(day);
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = day === null ? 'Choose a date first' : starts.length ? 'Select an available time' : 'No times available - choose another date';
      placeholder.disabled = true;
      field.time.replaceChildren(placeholder);
      starts.forEach(minute => {
        const option = document.createElement('option');
        option.value = timeValue(minute);
        option.textContent = `${timeLabel(minute)} - ${timeLabel(minute + config.duration)}`;
        field.time.append(option);
      });
      field.time.value = starts.includes(fromTime(oldValue)) ? oldValue : '';
      field.time.disabled = !currentScope() || !starts.length;
      field.time.required = !!field.input.value && !field.time.disabled;
      field.timeHelp.textContent = day === null
        ? 'Choose a date to see available times.'
        : `${config.duration / 60}-hour bookings. All times are Central Time (Richardson, TX).`;
      updateEnd(field);
      return !!oldValue && !field.time.value;
    }
    function clearField(field) {
      field.input.value = '';
      field.time.value = '';
      field.end.value = '';
      setError(field, '');
      setTimeError(field, '');
      showField(field);
      renderTimes(field, false);
    }
    function refresh(announce = true) {
      if (failed) return;
      try { updateClock(); } catch (error) { fail(error.message); return; }
      let clearedDate = false;
      let clearedTime = false;
      fields.forEach(field => {
        if (field.input.value && unavailable(fromISO(field.input.value))) {
          clearField(field);
          clearedDate = true;
        }
        field.button.disabled = !currentScope();
        showField(field);
        if (renderTimes(field)) {
          setTimeError(field, 'That time is no longer available. Please choose another time.');
          clearedTime = true;
        }
      });
      if (announce || clearedDate || clearedTime) {
        status.textContent = clearedDate
          ? 'A selected date has no available times for this reservation type. Please choose another date.'
          : clearedTime ? 'Availability has changed. Please choose another start time.'
          : currentScope()
            ? `Choose a date, then a time. ${config.duration / 60}-hour bookings; starts ${timeLabel(config.first)}-${timeLabel(config.last)}, Central Time. This is an inquiry, not a reservation.`
            : 'Choose your reservation type above to see available dates and times.';
      }
      submit.disabled = false;
    }
    function markFocused(day) {
      focusedDay = day;
      body.querySelectorAll('[data-day]').forEach(button => { button.tabIndex = Number(button.dataset.day) === day ? 0 : -1; });
    }
    function render(moveFocus = false) {
      if (failed || viewMonth === null) return;
      const first = dateOf(viewMonth);
      const year = first.getUTCFullYear();
      const month = first.getUTCMonth();
      const dayCount = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
      const leading = first.getUTCDay();
      const chosen = active ? fromISO(active.input.value) : null;
      monthLabel.textContent = monthFormatter.format(first);
      previous.disabled = viewMonth <= monthOf(clock.minimum);
      next.disabled = year === MAX_YEAR && month === 11;
      body.replaceChildren();
      const cellCount = Math.ceil((leading + dayCount) / 7) * 7;
      const fragment = document.createDocumentFragment();
      for (let row = 0; row < cellCount / 7; row++) {
        const tr = document.createElement('tr');
        for (let column = 0; column < 7; column++) {
          const n = row * 7 + column - leading + 1;
          const td = document.createElement('td');
          if (n < 1 || n > dayCount) { td.setAttribute('aria-hidden', 'true'); tr.append(td); continue; }
          const day = viewMonth + n - 1;
          const blocked = unavailable(day);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cc-calendar-day';
          button.textContent = String(n);
          button.dataset.day = String(day);
          button.tabIndex = day === focusedDay ? 0 : -1;
          button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
          button.setAttribute('aria-label', fullFormatter.format(dateOf(day)) + (blocked ? ', unavailable' : ''));
          if (day === clock.today) button.setAttribute('aria-current', 'date');
          if (day === chosen) { td.setAttribute('aria-selected', 'true'); button.classList.add('is-selected'); }
          td.append(button);
          tr.append(td);
        }
        fragment.append(tr);
      }
      body.append(fragment);
      const focusButton = body.querySelector(`[data-day="${focusedDay}"]`);
      if (moveFocus && focusButton) focusButton.focus({ preventScroll: true });
    }
    function closeCalendar() { if (dialog.open) dialog.close(); }
    function openCalendar(field) {
      refresh();
      if (failed || !currentScope()) return;
      active = field;
      focusedDay = fromISO(field.input.value) ?? clock.minimum;
      viewMonth = monthOf(focusedDay);
      title.textContent = field.required ? 'Choose your preferred date' : 'Choose an alternate date';
      field.button.setAttribute('aria-expanded', 'true');
      render(false);
      dialog.showModal();
      render(true);
    }
    function selectDay(day) {
      try { updateClock(); } catch (error) { fail(error.message); return; }
      if (!active || unavailable(day)) { render(false); return; }
      const field = active;
      const previousValue = field.input.value;
      field.input.value = iso(day);
      if (previousValue !== field.input.value) field.time.value = '';
      setError(field, '');
      setTimeError(field, '');
      showField(field);
      renderTimes(field);
      field.input.dispatchEvent(new Event('change', { bubbles: true }));
      status.textContent = `${field.label}: ${shortFormatter.format(dateOf(day))}. Now select an available start time.`;
      closeCalendar();
    }
    function moveMonth(amount, moveFocus) {
      const candidate = shiftMonth(focusedDay, amount);
      focusedDay = Math.max(candidate, clock.minimum);
      viewMonth = monthOf(focusedDay);
      render(moveFocus);
    }
    function stopSubmit(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    function validateAvailability(event) {
      if (failed) { stopSubmit(event); return; }
      try { updateClock(); } catch (error) { fail(error.message); stopSubmit(event); return; }
      if (!currentScope()) { stopSubmit(event); reservation.focus(); reservation.reportValidity(); return; }
      let firstInvalid = null;
      fields.forEach(field => {
        let dateError = '';
        let timeError = '';
        const day = fromISO(field.input.value);
        if (field.required && !field.input.value) dateError = 'Please choose your preferred date from the calendar.';
        else if (field.input.value && unavailable(day)) dateError = 'This date has no available times. Please choose another date.';
        if (!dateError && field.input.value) {
          const minute = fromTime(field.time.value);
          if (minute === null) timeError = 'Please choose an available start time for this date.';
          else if (!choices(day).includes(minute)) timeError = 'That time is unavailable. Please choose another available time.';
        } else if (!field.input.value && field.time.value) dateError = 'Please choose a date for this time, or clear this selection.';
        setError(field, dateError);
        setTimeError(field, timeError);
        if (!firstInvalid && dateError) firstInvalid = field.button;
        else if (!firstInvalid && timeError) firstInvalid = field.time;
        if (!dateError && !timeError) updateEnd(field);
      });
      if (firstInvalid) { stopSubmit(event); firstInvalid.focus(); }
      // Otherwise use the existing Shopify contact form submission unchanged.
    }

    instances.set(root, { destroy: () => {
      closeCalendar(); cleanup.abort(); window.clearInterval(timer); instances.delete(root);
    } });
    listen(form, 'submit', validateAvailability, { capture: true });
    try {
      if (typeof dialog.showModal !== 'function') throw new Error('This browser needs an update to use the availability calendar.');
      if (fields.length !== 2 || fields.some(field => !field.time || !field.timeHelp || !field.timeError || !field.end)) throw new Error('The date/time fields are incomplete. Install the whole section file.');
      if (!Number.isInteger(leadDays) || leadDays < 0 || leadDays > 30) throw new Error('Minimum notice must be 0 to 30 days.');
      config = {
        first: fromTime(root.dataset.ccFirstStart), last: fromTime(root.dataset.ccLastStart),
        duration: Number(root.dataset.ccDuration), step: Number(root.dataset.ccSlotStep),
        before: Number(root.dataset.ccBufferBefore), after: Number(root.dataset.ccBufferAfter)
      };
      if (config.first === null || config.last === null || config.last < config.first) throw new Error('Enter valid earliest/latest start times as HH:MM, with the latest not before the earliest.');
      if (!Number.isInteger(config.duration) || config.duration < 60 || config.duration > 480 || config.duration % 30) throw new Error('Booking duration must be 60-480 minutes, in 30-minute steps.');
      if (![15, 30, 60].includes(config.step)) throw new Error('Start-time intervals must be 15, 30 or 60 minutes.');
      if (config.last + config.duration > MINUTES_PER_DAY) throw new Error('The latest booking must finish by midnight. Adjust latest start or duration.');
      if ([config.before, config.after].some(n => !Number.isInteger(n) || n < 0 || n > 180)) throw new Error('Before/after buffers must be 0-180 minutes.');
      fullFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
      shortFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
      monthFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long', year: 'numeric' });
      clockFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: root.dataset.ccTimezone || 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const errors = [];
      root.querySelectorAll('[data-cc-block]').forEach((block, index) => {
        if (block.dataset.enabled !== 'true') return;
        const startText = (block.dataset.start || '').trim();
        const endText = (block.dataset.end || '').trim();
        if (!startText && !endText) return;
        const start = fromISO(startText);
        const end = fromISO(endText || startText);
        const scope = block.dataset.scope || 'both';
        if (start === null || end === null || end < start || !['both', 'hosted', 'rental'].includes(scope)) {
          errors.push(`Blocked dates #${index + 1}: use real YYYY-MM-DD dates, with the end on or after the start.`);
        } else rules.push({ start, end, scope });
      });
      root.querySelectorAll('[data-cc-time-block]').forEach((block, index) => {
        if (block.dataset.enabled !== 'true') return;
        const dateText = (block.dataset.date || '').trim();
        // A newly added timed block does nothing until its date is entered.
        if (!dateText) return;
        const day = fromISO(dateText);
        const startMinute = fromTime(block.dataset.startTime);
        const endMinute = fromTime(block.dataset.endTime, true);
        const scope = block.dataset.scope || 'both';
        if (day === null || startMinute === null || endMinute === null || endMinute <= startMinute || !['both', 'hosted', 'rental'].includes(scope)) {
          errors.push(`Blocked times #${index + 1}: use YYYY-MM-DD and 24-hour HH:MM times, with the end after the start on that date.`);
        } else timeRules.push({
          start: day * MINUTES_PER_DAY + startMinute - config.before,
          end: day * MINUTES_PER_DAY + endMinute + config.after,
          scope
        });
      });
      if (errors.length) throw new Error(errors.join(' '));
      const durationField = root.querySelector('[data-cc-booking-duration]');
      if (durationField) durationField.value = `${config.duration / 60} hours`;
      const summary = root.querySelector('[data-cc-admin-summary]');
      if (summary) summary.textContent = `${config.duration / 60}-hour bookings. Starts ${timeLabel(config.first)}-${timeLabel(config.last)}, every ${config.step} minutes. Buffers: ${config.before} minutes before and ${config.after} minutes after each timed block. Both dates and both time fields use these rules.`;
      updateClock();
    } catch (error) { fail(error.message); return; }

    fields.forEach(field => {
      listen(field.button, 'click', () => openCalendar(field));
      listen(field.clear, 'click', () => {
        clearField(field);
        status.textContent = `${field.label} and its time cleared.`;
        field.button.focus();
      });
      listen(field.time, 'change', () => {
        setTimeError(field, '');
        refresh(false);
        updateEnd(field);
        if (field.input.value && field.time.value) {
          const minute = fromTime(field.time.value);
          status.textContent = `${field.required ? 'Preferred' : 'Alternate'} request: ${shortFormatter.format(dateOf(fromISO(field.input.value)))}, ${timeLabel(minute)}-${timeLabel(minute + config.duration)} Central Time. This does not reserve the time.`;
        }
      });
    });
    listen(reservation, 'change', () => refresh());
    listen(previous, 'click', () => moveMonth(-1, false));
    listen(next, 'click', () => moveMonth(1, false));
    listen(close, 'click', closeCalendar);
    listen(dialog, 'close', () => {
      if (active) {
        active.button.setAttribute('aria-expanded', 'false');
        if (active.button.isConnected && !active.button.disabled) active.button.focus({ preventScroll: true });
      }
    });
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCalendar();
    });
    listen(body, 'click', event => {
      const button = event.target.closest('[data-day]');
      if (button) selectDay(Number(button.dataset.day));
    });
    listen(body, 'focusin', event => {
      const button = event.target.closest('[data-day]');
      if (button) markFocused(Number(button.dataset.day));
    });
    listen(body, 'keydown', event => {
      const button = event.target.closest('[data-day]');
      if (!button) return;
      const day = Number(button.dataset.day);
      let target = null;
      switch (event.key) {
        case 'ArrowLeft': target = day - 1; break;
        case 'ArrowRight': target = day + 1; break;
        case 'ArrowUp': target = day - 7; break;
        case 'ArrowDown': target = day + 7; break;
        case 'Home': target = day - dateOf(day).getUTCDay(); break;
        case 'End': target = day + 6 - dateOf(day).getUTCDay(); break;
        case 'PageUp': target = shiftMonth(day, event.shiftKey ? -12 : -1); break;
        case 'PageDown': target = shiftMonth(day, event.shiftKey ? 12 : 1); break;
        default: return;
      }
      event.preventDefault();
      focusedDay = Math.max(clock.minimum, Math.min(target, fromISO('9999-12-31')));
      viewMonth = monthOf(focusedDay);
      render(true);
    });
    listen(window, 'pageshow', () => refresh());
    listen(document, 'visibilitychange', () => {
      if (document.visibilityState === 'visible') { refresh(); if (dialog.open) render(false); }
    });
    listen(form, 'reset', () => {
      closeCalendar();
      window.setTimeout(() => {
        if (!root.isConnected) return;
        fields.forEach(clearField);
        refresh();
      }, 0);
    });
    // Recheck clock-dependent choices on long-open pages; never reserve a slot.
    timer = window.setInterval(() => {
      if (!root.isConnected) { instances.get(root)?.destroy(); return; }
      if (document.visibilityState === 'visible') { refresh(false); if (dialog.open) render(false); }
    }, 60000);
    refresh();
  }

  function scan(scope) {
    if (scope.matches && scope.matches(ROOT)) initialize(scope);
    scope.querySelectorAll(ROOT).forEach(initialize);
  }
  function boot() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches && event.target.matches(ROOT)) instances.get(event.target)?.destroy();
    event.target.querySelectorAll(ROOT).forEach(root => instances.get(root)?.destroy());
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
